import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { RequiredAction } from '../interfaces/auth/auth.interface';
import { UserService } from '../services/user.service';

/** Всё приложение, кроме входа (CRM-122, BR-16): без сессии — на вход, с временным паролем — на его смену. */
export const authGuard: CanActivateFn = (_route, state) => {
  const user = inject(UserService).userInfo$$();
  const router = inject(Router);
  if (!user) return router.createUrlTree(['/login'], { queryParams: { returnUrl: state.url } });
  if (user.requiredAction === RequiredAction.ChangePassword) {
    return router.createUrlTree(['/change-password'], { queryParams: { returnUrl: state.url } });
  }
  return true;
};
